module.exports = __webpack_public_path__ + "static/media/inter.91f54c76.svg";